// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { apiClient, signApiRequest } from ".";
import { useMutation } from "@tanstack/react-query";

export const createUser = async ({ signedData, email, phone, credentials }: { signedData: object; email: string; phone: string; credentials: object }) => {
  const givenName = signedData?.providerInfo?.seBankID?.completionData?.user?.givenName;
  const surname = signedData?.providerInfo?.seBankID?.completionData?.user?.surname;
  const personalNumber = signedData?.providerInfo?.seBankID?.completionData?.user?.personalNumber;

  if (!givenName || !surname || !personalNumber) {
    throw new Error("Missing required user information");
  }

  const userObject = {
    user: {
      email,
      phone,
      firstName: givenName,
      lastName: surname,
      ssn: personalNumber,
      birthDate: `${personalNumber.substring(0, 4)}-${personalNumber.substring(4, 6)}-${personalNumber.substring(6, 8)}T00:00:00Z`,
      fid: credentials.identityId,
    },
  };

  const signedRequest = await signApiRequest(
    "POST",
    `${import.meta.env.VITE_API_URL}/user/users`,
    credentials,
    { "content-type": "application/json" },
    userObject
  );

  const response = await apiClient({
    url: `/user/users`,
    method: "POST",
    headers: signedRequest.options.headers,
    data: signedRequest.options.body,
  });
  return response.data;
};

export const useCreateUser = () =>
  useMutation({
    mutationFn: ({ signedData, email, phone, credentials }: { signedData: unknown; email: string; phone: string; credentials: unknown }) => {
      return createUser({
        signedData,
        email,
        phone,
        credentials,
      });
    },
    onSuccess: (data) => {
      return data;
    },
    onError: (error) => {
      throw new Error(error);
    },
  });
